/*
 * Menu
 */

/* global $biro_body */
var $biro_header_menu;


// On page load
jQuery( function ( $ ) {

	// Init
	$biro_header_menu = $( '.header-menu' );

	// Toggle sub-menu
	$biro_header_menu.on( 'click', '.top-level-button', function ( e ) {

		// Init
		e.preventDefault();
		var $el = $( this );

		if ( $el.attr( 'aria-expanded' ) === 'false' ) {

			// Desktop actions...
			if ( ! $biro_vw_mobile ) {

				// Open overlay
				biro_overlay_open();

				// Close any open menus
				biro_menu_close_all();

				// Close search
				biro_search_form_close( false );

			}

			// Open this menu
			$el.attr( 'aria-expanded', 'true' );

			// Blur if clicking (rather than tabbing)
			if ( e.clientX > 0 ) {
				$el.blur();
			}

		} else {

			// Close overlay
			if ( ! $biro_vw_mobile ) {
				biro_overlay_close();
			}

			// Close this one
			$el.attr( 'aria-expanded', 'false' );

		}

	} );

	// Top-level control focus (used for styling not otherwise possible)
	$biro_header_menu.on( 'focus', '.top-level-control', function( e ) {
		$( this ).parents( '.header-menu-item' ).addClass( 'control-has-focus' );
	}).on( 'blur', '.top-level-control', function( e ) {
		$( this ).parents( '.header-menu-item' ).removeClass( 'control-has-focus' );
	});

	// Mobile toggle
	$biro_body.on( 'click', '.mobile-menu-toggle', function () {

		var $el = $( this );

		if ( $el.attr( 'aria-expanded' ) === 'false' ) {

			$biro_header_menu.removeClass( 'mobile-menu-closed' ).slideDown( 300 );
			$el.attr( 'aria-expanded', 'true' );

		} else {

			$biro_header_menu.slideUp( 300, function () {
				$biro_header_menu.addClass( 'mobile-menu-closed' );
			} );
			$el.attr( 'aria-expanded', 'false' ).blur();

		}

	} );

	// Overlay close
	$biro_body.on( 'biro:overlay:close', function() {
		biro_menu_close_all();
	});

} );


/**
 * Close any open nav menus
 *
 * @return {void}
 */
function biro_menu_close_all() {

	jQuery( '.top-level-control[aria-expanded]' ).attr( 'aria-expanded', 'false' );

}